module.exports = __webpack_public_path__ + "static/media/connected-active.629da675.svg";